var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M498.2,222.7L498.2,222.7L289.3,13.8C280.4,4.9,268.6,0,256,0s-24.4,4.9-33.3,13.8L13.9,222.6 c-0.1,0.1-0.1,0.1-0.2,0.2c-18.3,18.4-18.3,48.2,0.1,66.6c8.4,8.4,19.4,13.2,31.3,13.7c0.5,0,1,0.1,1.5,0.1h8.3v153.7 c0,30.4,24.7,55.2,55.2,55.2h81.7c8.3,0,15-6.7,15-15V376.5c0-13.9,11.3-25.2,25.2-25.2h48.2c13.9,0,25.2,11.3,25.2,25.2V497 c0,8.3,6.7,15,15,15H402c30.4,0,55.2-24.7,55.2-55.2V303.1h7.7c12.6,0,24.4-4.9,33.3-13.8C516.5,271,516.5,241.1,498.2,222.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.43d03704e7c560669235684029f295ec.svg";
export { ForwardRef as ReactComponent };